import { Component, OnInit } from '@angular/core';
import { FeedbackStatusFollowUpService } from '../service/feedback-status-followup.service';
import { FeedbackService } from '../service/feedback.service';
import { FileStatusModel } from '../model/file-status.model';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';
import { UserService } from '../shared/user.service';

@Component({
  selector: 'feedback-status-followup-totals',
  templateUrl: './feedback-status-followup-totals.component.html',
  styleUrls: ['./feedback-status-followup-totals.component.css']
})
export class FeedbackStatusFollowUpTotalsComponent implements OnInit {

  userDetails: any;
  accountManagers: any[];
  accountManagerSelected: any = null;
  resultTable: any[] = null;
  cols: any[];
  msgs: Message[] = [];
  reportMonthes: any[] = [];
  fromReportMonth: any = null;
  toReportMonth: any = null;

  constructor(private dataService: FeedbackStatusFollowUpService, private feedbackService: FeedbackService, private router: Router, private userService: UserService) { }

  ngOnInit() {
    

    this.userService.getUserClaims().subscribe((result: any) => {
      this.userDetails = result;
      if (!this.userDetails.ClientRoleAdministration && !this.userDetails.ClientRoleSupport && !this.userDetails.ClientRoleSemiAdministrator) {
        return this.showMessage('error', '', 'אינך מורשה למסך זה ');
      }
      this.dataService.getAccountManagersDDL().subscribe((result: any) => {
        this.accountManagers = result;
        if (this.userDetails.ClientRoleSupport && this.accountManagers && this.accountManagers.length==1) {
          this.accountManagerSelected = this.accountManagers[0].value;
        }
        this.accountManagerChanged();
      },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת מנהלי תיקים ');
      });

      this.fillReportMonth();
      
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בבדיקת הרשאות ');
    });

    
    

    this.cols = [
      { field: 'AccountManagerName', header: 'מנהל תיק' },
      { field: 'Positive_ReportsCount', header: 'רשומות נקלטו' },
      { field: 'Positive_SCHUM_HAFRASHA_Total', header: 'סכום נקלט' },
      { field: 'Total_ReportsCount', header: 'רשומות שלא נקלטו' },
      { field: 'Total_SCHUM_HAFRASHA', header: 'סכום שלא נקלט' },
      { field: 'Treatment_ReportsCount', header: 'רשומות בטיפול' },
      { field: 'Treatment_SCHUM_HAFRASHA_Total', header: 'סכום בטיפול' },
      { field: 'Denied_ReportsCount', header: 'רשומות נדחו' },
      { field: 'Denied_SCHUM_HAFRASHA_Total', header: 'סכום שנדחה' },

    ];
  }

  fillReportMonth() {
    // var curD = new Date();
    // curD.setMonth(curD.getMonth() - 24);
    // for(var i = 0; i < 24; i++) {
    //   var m = (curD.getMonth()).toString();
    //   m = (parseInt(m) + 1).toString();
    //   if (m.length==1) m = '0' + m;
    //   var label = curD.getFullYear().toString() + '/' + m;
    //   var value = curD.getFullYear().toString() + m;
    //   this.reportMonthes.push({label: label, value: value});
    //   curD.setMonth(curD.getMonth() + 1);
    // }

    this.feedbackService.GetReportMonthList().subscribe((result: any) => {
      this.reportMonthes = result;
      this.fromReportMonth = this.reportMonthes[0].value;
      this.toReportMonth = this.reportMonthes[0].value;
      
    },
    (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת רשימת תקופות ');
    });



    
  }

  accountManagerChanged() {
    
  }

  getData(): void {
    

    this.dataService.getDataTotals(this.accountManagerSelected, this.fromReportMonth, this.toReportMonth).subscribe((result: any) => {
      this.resultTable = result;
    }, (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת נתונים ');
    });
  }

  

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }



}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/feedback-status-followup-totals/feedback-status-followup-totals.component.ts